import request from '@/utils/request'

const key = 'account'

// 查询账号列表
export function fetchAdminAccountList(params) {
  return request({
    url: `/platform/${key}`,
    method: 'get',
    params: {
      ...params
    }
  })
}

// 新增账号
export function createAdminAccount(data) {
  return request({
    url: `/platform/${key}`,
    method: 'post',
    data
  })
}

// 编辑账号
export function updateAdminAccount(id, data) {
  return request({
    url: `/platform/${key}/${id}`,
    method: 'post',
    data
  })
}

// 批量禁用/启用
export function updateMultiStatus(data) {
  return request({
    url: `/platform/${key}/status`,
    method: 'post',
    data
  })
}
